import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export interface SessionPageHeaderProps {
    title: string;
    description: string;
    backTo?: string;
}

export function SessionPageHeader({ title, description, backTo = '/app/sessions' }: SessionPageHeaderProps) {
    return (
        <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-4">
                <Button variant="outline" size="sm" asChild>
                    <Link to={backTo}>
                        <ArrowLeft />
                        Back
                    </Link>
                </Button>
                <div>
                    <h1 className="text-3xl font-bold tracking-tight">{title}</h1>
                    <p className="text-sm text-muted-foreground mt-1">{description}</p>
                </div>
            </div>
        </div>
    );
}
